import Carousel from 'antd/lib/carousel'

import 'antd/lib/carousel/style'

export * from 'antd/lib/carousel'

export default Carousel
